
/** 配置数据 ::: 
 *  @data {Map<String,Number>} allFormTypeIndex 表单类型序号字典
 */
import { allFormTypeIndex } from "@/assets/js/form_dictionary.js";
/** 工具方法 :::
 *  @function makeComputedGroup 生成计算属性组方法
 */
import { makeComputedGroup } from "@/utils/computed_utils.js";

/** @name mixRiceIndex 公共混入部分
 *  @author 王汝鹏
 *  @version 2019-12-24
 */
export const mixRiceIndexCommon = {
  computed: {
    /** 计算属性说明 ::: 
     *  @return {Object} activeNode 激活表单项
     *  @return {Array<Object>} activeList 激活表单项的父级
     *  @return {Object} formSettingState 表单属性设置
     *  @return {Array<Object>} formList 拖拽区表单数据
     *  @return {Object} formMap 表单项字典 { formId: 表单项配置对象 }
     *  @return {Object} eventMap 事件字典 { 事件id: 事件配置 }
     *  @return {Object} variableMap 变量配置字典 { model: 其他变量名称 }
     *  @return {Array<Object>} domainList 模块组件列表
     *  @return {Object} domainEditProcess 模块编辑过程数据
     *  @return {String} expandFunction 扩展功能 { "none":不启用任何扩展功能, "group":启用分组管理功能 }
     */
    ...makeComputedGroup('mix_rice_index_store', {
      activeNode: "activeNode",
      activeList: "activeList",
      formSettingState: "formSettingState",
      formList: {
        get: "formList",
        set(val) {
          if (this.domainEditManager().getOperation() === 'name') return [];
          if (this.domainEditManager().getStatus() !== 'normal') { this.domainEditManager().setTemplates(val); }
          return val;
        }
      },
      formMap: "formMap",
      eventMap: "eventMap",
      variableMap: "variableMap",
      domainList: "domainList",
      domainEditProcess: "domainEditProcess",
      expandFunction: "expandFunction",
    }),
  },
  methods: {
    /** @name 扫描表单项配置字典
     *  @param {Object} formMap 表单项字典
     *  @return {Boolean} 操作结果
     *  @author 王汝鹏
     *  @version 2019-12-24
     */
    scanFromMap(formMap) {
      // 重置各类型计数索引
      for (let [key,value] of allFormTypeIndex) {
        allFormTypeIndex.set(key, 0);
      }

      for (let id in formMap) {
        let config = formMap[id];
        let { type } = config.node;
        let { customName } = config.baseOption;

        // 自动生成的表单项自定义名称规则: type_00000001
        if (/\W+_(\d+)/.test(customName)) {
          // 匹配表单项名称中的索引
          let result = customName.match(/\W+_(\d+)/);
          let index = Number(result[1]);

          if (Number(allFormTypeIndex.get(type))<index)
              allFormTypeIndex.set(type, index);
        }
      }
    },
    /** @name 导入模板配置
     *  @param {Object} templateConfig 模板配置数据
     *  @return {Boolean} 操作结果
     *  @author 王汝鹏
     *  @version 2020-01-13 
     */
    importTemplateConfig(templateConfig) {
      // 更新数据到store中
      let { domainList=[], formList=[], formMap={}, eventMap={}, variableMap={} } = templateConfig;
      this.mix_rice_index_store.domainList = domainList;
      this.mix_rice_index_store.formList = formList;
      this.mix_rice_index_store.eventMap = eventMap;
      this.mix_rice_index_store.formMap = formMap;
      this.mix_rice_index_store.variableMap = variableMap;
      this.scanFromMap(formMap);
    }
  }
}




// WEBPACK FOOTER //
// ./src/mixins/rice_index/mix_rice_index_common.js